import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for TeamsStore, for use in the registry */ export const TeamsStoreActionTypes = [
    ActionType.DeleteTeamsTasksTabSucceeded,
    ActionType.FetchChannelSucceeded,
    ActionType.FetchTeamsMessageDetailsSucceeded,
    ActionType.FetchTeamsTasksTabs,
    ActionType.FetchTeamsTasksTabsFailed,
    ActionType.FetchTeamsTasksTabsSucceeded
];
